// src/components/SupabaseAuthStyleTest.js
// NOTE: This component is kept ONLY for CSS/styling testing for Supabase auth page
// NOT for functional auth testing - use actual Supabase auth at /
import React, { useState } from 'react';
import { useSupabaseAuth } from '../hooks/useSupabaseAuth';
import logger from '../services/logger';

const SupabaseAuthStyleTest = () => {
  const { user, signIn, signUp, signOut, loading, error, isAuthenticated } = useSupabaseAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    displayName: ''
  });
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [dbStatus, setDbStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isRegisterMode) {
        await signUp(formData.email, formData.password, { display_name: formData.displayName });
      } else {
        await signIn(formData.email, formData.password);
      }

      // Clear form
      setFormData({ email: '', password: '', displayName: '' });
    } catch (err) {
      logger.error('Auth error:', err);
    }
  };

  const testDatabase = async () => {
    // Database testing removed - this is style testing only
    setDbStatus({ message: 'This component is for CSS testing only. Use / for actual auth.' });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '500px', 
      margin: '0 auto',
      backgroundColor: '#1a1a1a',
      color: 'white',
      borderRadius: '8px',
      marginTop: '50px'
    }}>
      <h2>🧪 Database Auth Test</h2>
      
      {/* Database Status Test */}
      <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#2a2a2a', borderRadius: '4px' }}>
        <button onClick={testDatabase} style={{ marginBottom: '10px', padding: '8px 16px' }}>
          Test Database Connection
        </button>
        {dbStatus && (
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(dbStatus, null, 2)}
          </pre>
        )}
      </div>

      {/* Authentication Status */}
      {isAuthenticated ? (
        <div style={{ marginBottom: '20px' }}>
          <h3>✅ Logged in as: {user.email}</h3>
          <p>Display Name: {user.displayName}</p>
          <p>User ID: {user.id}</p>
          <button onClick={signOut} style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px' }}>
            Logout
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
          <h3>{isRegisterMode ? 'Register' : 'Login'}</h3>
          
          {error && (
            <div style={{ color: '#dc3545', marginBottom: '10px', padding: '8px', backgroundColor: '#2a2a2a', borderRadius: '4px' }}>
              {error}
            </div>
          )}
          
          <div style={{ marginBottom: '10px' }}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              style={{ width: '100%', padding: '8px', marginBottom: '10px', backgroundColor: '#333', color: 'white', border: '1px solid #555', borderRadius: '4px' }}
            />
          </div>
          
          <div style={{ marginBottom: '10px' }}>
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
              required
              style={{ width: '100%', padding: '8px', marginBottom: '10px', backgroundColor: '#333', color: 'white', border: '1px solid #555', borderRadius: '4px' }}
            />
          </div>
          
          {isRegisterMode && (
            <div style={{ marginBottom: '10px' }}>
              <input
                type="text"
                name="displayName"
                placeholder="Display Name"
                value={formData.displayName}
                onChange={handleInputChange}
                required
                style={{ width: '100%', padding: '8px', marginBottom: '10px', backgroundColor: '#333', color: 'white', border: '1px solid #555', borderRadius: '4px' }}
              />
            </div>
          )}
          
          <button 
            type="submit" 
            disabled={loading}
            style={{ width: '100%', padding: '10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', marginBottom: '10px' }}
          >
            {loading ? 'Processing...' : (isRegisterMode ? 'Register' : 'Login')}
          </button>
          
          <button 
            type="button" 
            onClick={() => setIsRegisterMode(!isRegisterMode)}
            style={{ width: '100%', padding: '8px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}
          >
            Switch to {isRegisterMode ? 'Login' : 'Register'}
          </button>
        </form>
      )}
    </div>
  );
};

export default SupabaseAuthStyleTest;